module.exports = __webpack_public_path__ + "img/bitbucket.fbb46497.svg";